<template>
    <div class="c-warning-box">
    <div class="u-d-flex">
        <icons></icons>
        <div @click="toggleModal">
            <slot name="icon"></slot>
        </div>
        <slot></slot>
    </div>
    <div class="u-d-flex">
        <div @click="toggleModal">
            <slot name="b"></slot>
        </div>
    </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Modal from 'components/modal/Modal.vue';
    import Icons from 'components/Icons.vue';

    export default {
        name: 'warning-box',
        props: {
            modalName:{
                type:String,
                default: ''
            },
        },
        components: {
            Modal,
            Icons
        },
        methods: {
            ...mapActions('modal', ['toggle', 'getModalContent']),
            toggleModal() {
                this.toggle(this.modalName);
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/sass/base/colours.scss';
    @import '../../assets/sass/base/fonts.scss';
	@import '../../assets/sass/view/component/warning-box.scss';
</style>


// WEBPACK FOOTER //
// WarningBox.vue?2bcb8c74